import { IMediaModel, TimeHelper, useIsLoggedIn } from "@nf/common";

import MyListButton from "components/MyListButton";
import PlayButton from "components/PlayButton";
import TrailerButton from "components/TrailerButton";

import styles from "./MediaActionButtons.module.scss";

export interface MediaActionButtonsProps {
  media: IMediaModel;
  showTrailer?: boolean;
}

const MediaActionButtons = ({
  media,
  showTrailer,
}: MediaActionButtonsProps) => {
  const isExpired = TimeHelper.isBeforeCurrent(media.AvailableTo);

  return (
    <div className={styles.actions}>
      <PlayButton media={media} />

      {showTrailer && media.TrailerMediaId && <TrailerButton media={media} />}

      {!isExpired && <MyListButton media={media} />}
    </div>
  );
};

export default MediaActionButtons;
